import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-step-bar',
  templateUrl: './step-bar.component.html',
  styleUrls: ['./step-bar.component.scss']
})
export class StepBarComponent implements OnInit {
  @Input() steps
  @Input() page

  constructor() { }

  ngOnInit(): void {
  }

}
